import {
  START_CALL_SESSION,
  START_CALL_SESSION_SUCCESS,
  START_CALL_SESSION_ERROR,
} from '../constants/ActionTypes';
import { RequestStatus } from '../models/requestStatus';

const INIT_STATE = {
  callsSessionsInfo: [],
};

/* shape for 'callsSessionsInfo'
* callsSessionsInfo: [{
* userId: string,
* responseStatus: one of CALL_SESSION_STATUSES,
* requestStatus: RequestStatus,
* }]
* */

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case START_CALL_SESSION: {
      let { callsSessionsInfo } = state;

      const isOldStatus = callsSessionsInfo.some(
        loadStatus => loadStatus.userId === action.payload.userId,
      );

      // we should check if previous loading status stored here
      if (isOldStatus) {
        callsSessionsInfo = callsSessionsInfo.map(loadStatus => {
          if (loadStatus.userId === action.payload.userId) {
            return {
              ...loadStatus,
              responseStatus: undefined,
              requestStatus: new RequestStatus(true),
            };
          }
          return loadStatus;
        });
      } else {
        callsSessionsInfo = [
          ...callsSessionsInfo,
          {
            userId: action.payload.userId,
            responseStatus: undefined,
            requestStatus: new RequestStatus(true),
          },
        ];
      }

      return {
        ...state,
        callsSessionsInfo,
      };
    }
    case START_CALL_SESSION_SUCCESS: {
      const callsSessionsInfo = state.callsSessionsInfo.map(loadStatus => {
        if (loadStatus.userId === action.payload.userId) {
          return {
            ...loadStatus,
            responseStatus: action.payload.responseStatus,
            directPhoneNumber: action.payload.directPhoneNumber,
            requestStatus: new RequestStatus(false, true),
          };
        }
        return loadStatus;
      });

      return {
        ...state,
        callsSessionsInfo,
      };
    }
    case START_CALL_SESSION_ERROR: {
      const callsSessionsInfo = state.callsSessionsInfo.map(loadStatus => {
        if (loadStatus.userId === action.payload.userId) {
          return {
            ...loadStatus,
            responseStatus: undefined,
            requestStatus: new RequestStatus(false, false, action.payload.error),
          };
        }
        return loadStatus;
      });

      return {
        ...state,
        callsSessionsInfo,
      };
    }
    default: {
      return state;
    }
  }
};
